// extracted by mini-css-extract-plugin
module.exports = {"user_update":"SwitchAccountMain_user_update__35Lhi","main":"SwitchAccountMain_main__2quQQ","form":"SwitchAccountMain_form__2LXDP"};